import React, { } from "react";
import { Select } from "antd";
import { GlobalOutlined } from "@ant-design/icons";

function CountryLanguages({ list, selectProps = {} }) {
    return (
        <Select
            style={{
                width: 100
            }}
            disabled
            suffixIcon={<GlobalOutlined />}
            showSearch
            placeholder="Search to language"
            optionFilterProp="children"
            filterOption={(input, option) => (option?.label ?? "").includes(input)}
            filterSort={(optionA, optionB) => (optionA?.label ?? "").toLowerCase().localeCompare((optionB?.label ?? "").toLowerCase())}
            options={list.map((text) => ({
                value: text,
                label: text
            }))}
            {...selectProps}
        />
    );
}

export default CountryLanguages;
